<template>
  <div class="pageHotZy">
    <h3>热门专业</h3>
    <dl>
      <!-- <dt><img src="../assets/img/hotZy_bg.jpg" alt=""></dt> -->
      <dd v-for="i in rmzyList" :key="i.ID">
        <router-link :to="i.Url">
          <i :style="'background-image:url('+i.Cover+')'"></i>
          <p>
            <span>{{ i.Title }}</span>
          </p>
        </router-link>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      rmzyList: []
    };
  },
  mounted() {
    var that = this;
    var zyList = that.Base.GetNewsInfoByCid(
      "",
      that.api.zysz,
      "",
      "",
      "",
      1,
      "",
      30
    ).row;
    var zyTemp = [];
    for (let key in zyList) {
      if (zyList[key].Hot) {
        zyTemp.push(zyList[key]);
      }
    }
    that.rmzyList = zyTemp;
    // console.log(zyTemp);
  },
  methods: {}
};
</script>
</script>

<style>
.pageHotZy {
  width: 100%;
  background-color: #fff;
  padding-top: 30px;
}
.pageHotZy h3 {
  width: 690px;
  margin: 0 auto;
  font-size: 26px;
  color: #4a77f6;
  line-height: 1;
  padding-left: 11px;
  border-left: solid 4px #4a77f6;
}
.pageHotZy dl {
  width: 710px;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
}
.pageHotZy dd {
  width: 205px;
  height: 205px;
  position: relative;
  overflow: hidden;
  background: url(../assets/img/rmzy_bg.jpg) center no-repeat;
  background-size: 100% 100%;
  margin-top: 20px;
  box-sizing: border-box;
  padding-top: 20px;
}
.pageHotZy i {
  display: block;
  width: 160px;
  height: 100px;
  margin: 0 auto;
  /* margin-top: 40px; */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  transition: all 0.4s;
}
/* .pageHotZy dd:nth-child(1) i {
  background-image: url(../assets/img/rmzy_icon1.png);
}
.pageHotZy dd:nth-child(2) i {
  background-image: url(../assets/img/rmzy_icon2.png);
}
.pageHotZy dd:nth-child(3) i {
  background-image: url(../assets/img/rmzy_icon3.png);
}
.pageHotZy dd:nth-child(4) i {
  background-image: url(../assets/img/rmzy_icon4.png);
}
.pageHotZy dd:nth-child(5) i {
  background-image: url(../assets/img/rmzy_icon5.png);
}
.pageHotZy dd:nth-child(6) i {
  background-image: url(../assets/img/rmzy_icon6.png);
} */
.pageHotZy p {
  height: 80px;
  position: relative;
}
.pageHotZy span {
  display: block;
  width: 80%;
  line-height: 1.2;
  font-size: 22px;
  color: #333;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pageHotZy dt {
  width: 100%;
  height: 91px;
}
.pageHotZy dd:hover img {
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/rmzy.vue